var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_298_2724)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-circle",
    clipPath: "url(#clip1_298_2724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5307 16.8007C14.8391 16.8007 18.3317 13.3081 18.3317 8.99973C18.3317 4.69135 14.8391 1.19873 10.5307 1.19873C6.22236 1.19873 2.72974 4.69135 2.72974 8.99973C2.72974 13.3081 6.22236 16.8007 10.5307 16.8007Z",
    stroke: "#3A3A3A",
    strokeWidth: 1.5602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.97058 5.87939L13.6512 8.99979L8.97058 12.1202L8.97058 5.87939Z",
    fill: "#3A3A3A",
    stroke: "#3A3A3A",
    strokeWidth: 1.5602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_2724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7224,
    height: 18.7224,
    fill: "white",
    transform: "translate(19.5308) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_298_2724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7224,
    height: 18.7224,
    fill: "white",
    transform: "translate(1.16956 -0.361328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleIcon);
export default __webpack_public_path__ + "static/media/play_circle_icon.0e0acd06fdbe2b40f9d3c8e19d103b9f.svg";
export { ForwardRef as ReactComponent };